


























import _ from "lodash";
import AppPage from "@/components/AppPage.vue";
import ChangePasswordCard from "@/views/App/Components/ChangePasswordCard.vue";

import { LicenseModuleEnum, defaultLicenseModuleEnumSorting } from "@/model/data/License/LicenseModuleEnum";
import { mapActions, mapState } from "vuex";
import { GET_CURRENT_USER } from "@/store/modules/AuthenticationModule/actions";
import { RootState } from "@/store";

export default {
    components: {
        AppPage,
        ChangePasswordCard,
    },
    data() {
        return {
            cols: 4,
        };
    },
    computed: {
        ...mapState({
            passwordValidDays: (state: RootState) => state.authMod.passwordValidDays,
        }),

        shortcuts() {
            return this.$store.getters.homeShortcuts;
        },
        groupedShortcuts() {
            let res = [];
            const groupBy = _.groupBy(this.$store.getters.homeShortcuts, "requiredLicenseModules[0]");
            let licenseModules = this.defaultLicenseModuleEnumSorting();

            // prima ordino i moduli di licenza
            licenseModules.forEach((licenseModule) => {
                if (groupBy[licenseModule]) res.push(groupBy[licenseModule]);
            });

            // poi aggiungo il resto (tools)
            Object.keys(groupBy).forEach((k) => {
                if (licenseModules.indexOf(+k) < 0) res.push(groupBy[k]);
            });
            return res;
        },
        tableShortcuts() {
            let res = [];
            let i;
            for (i = 0; i < Math.ceil(this.$store.getters.homeShortcuts.length / this.cols); i++) {
                res.push(this.$store.getters.homeShortcuts.slice(i * this.cols, (i + 1) * this.cols));
            }
            return res;
        },
    },
    methods: {
        ...mapActions([GET_CURRENT_USER]),
        defaultLicenseModuleEnumSorting,
        convertString(str) {
            switch (str) {
                case LicenseModuleEnum.ServiceAndUpdatesManagement:
                    return this.$t("common.license_module.service_and_updates_management");
                case LicenseModuleEnum.CashFlowManagement:
                    return this.$t("common.license_module.cash_flow_management");
                case LicenseModuleEnum.FitnessStatistics:
                    return this.$t("common.license_module.fitness_statistics");
                case LicenseModuleEnum.SecurityManagement:
                    return this.$t("common.license_module.security_management");
                case LicenseModuleEnum.PredictiveMaintenance:
                    return this.$t("common.license_module.predictive_maintenance");
                case LicenseModuleEnum.RemoteLink:
                    return this.$t("common.license_module.remote_link");
                case LicenseModuleEnum.OneTimeCode:
                    return this.$t("common.license_module.one_time_code");
                default:
                    return "";
            }
        },

        async getCurrentUser() {
            console.log("getCurrentUser()");
            await this[GET_CURRENT_USER]();
        },
    },
};
